import React from 'react';
import PropTypes from 'prop-types';

export default function WarningsSection({ blindSpots, amateurGiveaways }) {
  if (!blindSpots?.length && !amateurGiveaways?.length) return null;

  const renderList = (items, label) => (
    <div className="mb-3">
      <h6>{label}</h6>
      <ul className="mb-0 ps-3">
        {items.map((item, idx) => (
          <li key={idx}>
            <strong>{item.importance?.toUpperCase()}</strong>: {item.description}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div>
      {blindSpots?.length > 0 && renderList(blindSpots, "Blind Spots")}
      {amateurGiveaways?.length > 0 && renderList(amateurGiveaways, "Amateur Giveaways")}
    </div>
  );
}

WarningsSection.propTypes = {
  blindSpots: PropTypes.arrayOf(
    PropTypes.shape({
      importance: PropTypes.string,
      description: PropTypes.string
    })
  ),
  amateurGiveaways: PropTypes.arrayOf(
    PropTypes.shape({
      importance: PropTypes.string,
      description: PropTypes.string
    })
  )
};
